import script from "./ModalFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalFrame.vue?vue&type=script&setup=true&lang=js"

import "./ModalFrame.vue?vue&type=style&index=0&id=78ef3909&lang=sass"

const __exports__ = script;

export default __exports__